import Layout from "./components/Layout";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import { Routes, Route } from "react-router-dom";
import { tabs } from "./tabs";
import { portfolio, store } from "./portfolio";
import CategoryView from "./components/CategoryView";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        {tabs.map((route) => {
          return <Route key={route.id} path={route.path} element={<route.element />} />
        })}
        {portfolio.map((category) => {
          return <Route key={category.title.toLowerCase()} path={category.title.toLowerCase()} element={<CategoryView name={category.title} />} />
        })}
        {store.map((category) => {
          return <Route key={category.title.toLowerCase()} path={category.title.toLowerCase()} element={<CategoryView name={category.title} />} />
        })}
        <Route path="*" element={<NoPage />} />
      </Route>
    </Routes>
  );
}

  export default App;
